import { useState } from 'react'
import { Moon, Sun } from '@ui/icons'
import { cx } from '@ui/classes'
import { getStoredTheme, toggleTheme, type Theme } from '@core/theme/theme'

/** Переключатель светлой/тёмной темы. Доступен и на кассе, и в админке. */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const [theme, setTheme] = useState<Theme>(() => getStoredTheme())
  const dark = theme === 'dark'

  const onClick = () => setTheme((current) => toggleTheme(current))

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={dark ? 'Включить светлую тему' : 'Включить тёмную тему'}
      aria-pressed={dark}
      title={dark ? 'Светлая тема' : 'Тёмная тема'}
      className={cx(
        // Форма и размеры совпадают с NavTab: переключатель стоит в одном ряду
        // с «Касса»/«Кабинет» и не должен выбиваться овалом.
        'inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-md border border-lineStrong bg-white text-ink transition-colors hover:bg-soft',
        compact ? 'px-2.5 py-1.5 text-small' : 'px-4 py-2 text-base2'
      )}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
      {!compact && <span className="hidden sm:inline">{dark ? 'Светлая' : 'Тёмная'}</span>}
    </button>
  )
}
